import { integerFormatter, numberFormatter, shortDateFormatter } from "../../gridFormatters";
import { wtAvg } from "../../math";


export const hostLunListDefs = [
    {
        "field": "collection_date",
        "headerName": "Collection Date",
        "filter": "agDateColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": shortDateFormatter,
        "enableRowGroup": true
    },
    {
        "field": "device_name",
        "headerName": "Array Name",
        "enableRowGroup": true
    },
    {
        "field": "host_name",
        "headerName": "Host Name",
        "enableRowGroup": true
    },
    {
        "field": "lun_name",
        "headerName": "LUN Name",
        "enableRowGroup": true
    },
    {
        "field": "volume",
        "headerName": "Volume",
        "enableRowGroup": true
    },
    {
        "field": "used",
        "headerName": "Used",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": integerFormatter,
        "aggFunc": "sum"
    },
    {
        "field": "lun_size",
        "headerName": "LUN Size",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": integerFormatter,
        "aggFunc": "sum"
    },
    {
        "field": "pool_name",
        "headerName": "Pool Name",
        "enableRowGroup": true
    },
    {
        "field": "free",
        "headerName": "Free",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": integerFormatter
    },
    {
        "field": "wwn",
        "headerName": "WWN"
    },
    {
        "field": "read_io",
        "headerName": "Read IOPs",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": numberFormatter,
        "aggFunc": "sum"
    },
    {
        "field": "write_io",
        "headerName": "Write IOPs",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": numberFormatter,
        "aggFunc": "sum"
    },
    {
        "field": "read_latency",
        "headerName": "Read Latency",
        "cellRenderer": numberFormatter,
        "aggFunc": p => wtAvg(p, "read_latency", "read_io")
    },
    {
        "field": "write_latency",
        "headerName": "Write Latency",
        "cellRenderer": numberFormatter,
        "aggFunc": p => wtAvg(p, "write_latency", "read_io")
    }
]